import { render } from "./ApiKeys.vue?vue&type=template&id=456b55c2"
import script from "./ApiKeys.vue?vue&type=script&lang=js"
export * from "./ApiKeys.vue?vue&type=script&lang=js"

import "./ApiKeys.vue?vue&type=style&index=0&id=456b55c2&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__